<template>
  <nav class="ui left fixed vertical menu fuzzy-list">
    <Spinny :promise="alertsPromise" />
    <Placy
      v-if="!alerts.length"
      :promise="alertsPromise"
      :empty-message="$t('NO_THING_YET', { thing: $tc('ALERT', 2) })"
      :error-message="$t('ERR', { action: $t('READ', { thing: $tc('ALERT', 2) }) })"
    />

    <router-link class="item" :to="{ name: 'new-alert' }">
      <i class="plus icon" />
      <strong>{{ $t('NEW', { thing: $tc('ALERT', 1) }) }}</strong>
    </router-link>

    <router-link
      v-for="alert in alerts"
      :key="alert.id"
      class="item"
      :active-class="'active'"
      :to="{ name: 'alert', params: { alertId: alert.id } }"
    >
      <div class="single-alert">
        <div>{{ alert.name }}</div>
        <alert-log :alertId="alert.id" :disabled="!alert.enabled" />
      </div>
    </router-link>
  </nav>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';

nav {
  overflow-y: scroll;
}

.group {
  font-weight: bold;
  margin-bottom: 0.5em;
}

.single-alert {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
}
</style>

<script>
// @flow
import _ from 'lodash'
import { Spinny, Placy } from 'ui'
import Vue from 'vue'
import { EsteroAlert, EsteroAlertLog, Toast, Typenames, Group } from 'services'
import fuzzy from 'fuzzy'
import AlertLog from './AlertLog.vue'

export default {
  name: 'alert-list',
  components: { Spinny, Placy, AlertLog },

  data() {
    return {
      alertsPromise: null
    }
  },

  computed: {
    alerts() {
      return this.$store.state.estero_alert.items
    }
  },

  created() {
    this.alertsPromise = EsteroAlert.readAll()
  }
}
</script>
